// removed by extract-text-webpack-plugin
module.exports = {"addressSearch":"_3bDy1","addressSearchInput":"_26a0H","addressSearchSuggests":"_1low6","addressSearchSuggestsHidden":"_1Lh2g"};


//////////////////
// WEBPACK FOOTER
// ./banquet/components/AddressSearch/index.sass
// module id = 1456
// module chunks = 1